//interlining - use D7

export function calculateD7(totalWidths, interliningOrBlackout,lining, COM) {
      console.log('calculateD7() start');
      console.log('- ',totalWidths, interliningOrBlackout, COM);
      
      if (interliningOrBlackout == true || lining ==  "RM Designer Deluxe Cotton Sateen" || lining == "RM Designer Deluxe Cotton FR Sateen" || lining == "RM Designer Recycled Royal Satin" || lining == "RM Designer Napped Sateen") {
            if (COM == true) {
                  switch (totalWidths) {
                        case 1:
                              return 173;
                        case 2:
                              return 308;
                        case 3:
                              return 448;
                        case 4:
                              return 615;
                        case 5:
                              return 777;
                        case 6:
                              return 939;
                        case 7:
                              return 1101;
                        case 8:
                              return 1247;
                        case 9:
                              return 1408;
                        case 10:
                              return 1554;
                        default:
                              console.log(
                                    '- invalid totalWidths. must be 1-10'
                              );
                              return 0;
                  }
            } else {
                  switch (totalWidths) {
                        case 1:
                              return 152;
                        case 2:
                              return 271;
                        case 3:
                              return 395;
                        case 4:
                              return 543;
                        case 5:
                              return 686;
                        case 6:
                              return 829;
                        case 7:
                              return 972;
                        case 8:
                              return 1100;
                        case 9:
                              return 1243;
                        case 10:
                              return 1372;
                        default:
                              console.log(
                                    '- invalid total width. must be 1-10'
                              );
                              return 0;
                  }
            }
      } else {
            return 0;
      }
}
